// STYLES
import * as Style from "./LockerItemStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./LockerItemModel";

// ASSETS
import ContainerImage from "assets/Icons/ContainerImage.svg";

// REDUX

// COMPONENTS

const LockerItem = (props: IProps) => {
  // PROPS
  const {
    lockerDetails = {
      name: "",
      status: "",
      noOfSlots: 0,
      noOfAvailableSlots: 0,
      noOfAvailableSupBoards: 0,
      noOfSupBoards: 0,
      id: 0,
    },
    onClick = () => {},
  } = props;

  // CONSTANTS USING LIBRARIES
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS
  const navigate = useNavigate();

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleNavigate = () => {
    navigate("/edit-locker", {
      state: {
        lockerId: lockerDetails.id,
      },
    });
  };
  return (
    <Style.ContainerItem>
      <Style.TopContainer>
        <Style.TitleIconContainer>
          <Style.TitleContainer>
            {t("component.lockerItem.title")} {lockerDetails.name}
          </Style.TitleContainer>
          <Style.EditIconContainer onClick={handleNavigate} size="medium" />
        </Style.TitleIconContainer>
        <Style.StatusContainer>{lockerDetails.status}</Style.StatusContainer>
      </Style.TopContainer>
      <Style.DetailsContainer onClick={onClick}>
        <Style.TextDetailsContainer>
          {t("component.lockerItem.availableBoards")}{" "}
          {lockerDetails.noOfAvailableSupBoards}/{lockerDetails.noOfSupBoards}
        </Style.TextDetailsContainer>
        <Style.TextDetailsContainer>
          {t("component.lockerItem.availableDoors")}{" "}
          {lockerDetails.noOfAvailableSlots}/{lockerDetails.noOfSlots}
        </Style.TextDetailsContainer>
        <Style.ImageContainer>
          <Style.ImageContent src={ContainerImage} alt="" />
        </Style.ImageContainer>
      </Style.DetailsContainer>
    </Style.ContainerItem>
  );
};
export default LockerItem;
